
<template>
  <v-container grid-list-xs class="mt-4" style="max-width: 1070px">
    <v-row align="center" justify="center" >
      <v-col cols="12" align="center" >
        <div>
          <h1>Convocatoria</h1>
        </div>
      </v-col> 
    </v-row>

    <div v-show="!registro" class="my-5">
      <v-container>
        <v-row class="text-center" justify="center">
          <v-alert type="info" max-width="520">Aún no se ha cargado la convocatoria</v-alert>
        </v-row>
      </v-container>
    </div>

    <div v-show="registro" class="my-5 mx-1">
      <v-row class="text-center" justify="center">
		    <object  type="application/pdf" style="width:100%;height:100vh;" :data="convocatoriaRuta"></object>
        <!-- <pdf :src="convocatoriaRuta">Convocatoria</pdf> -->

      </v-row>
    </div>
  </v-container>
</template>

<script>
import pdf from 'vue-pdf'

import axios from 'axios';
import { documentosBaseURL }  from '@/general';

export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Convocatoria  - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  components: {
    pdf
  },
  data () {
    return {
      registro: false,
      convocatoriaRuta: null,
    }
  },

  created(){
    this.getConvocatoria()
  },

  methods:{
    async getConvocatoria() {  
      let response = await this.convocatoria();
      if(response.state == '1'){
        delete response['state']
        if(Object.keys(response).length === 0){
          this.registro = false
        }else{
          this.registro = true
          this.convocatoriaRuta = documentosBaseURL + response.ruta
        }
      } // que hacer en caso de otros estados?

    },

    convocatoria(data){
      return new Promise((resolve, reject) => {
        axios.post('convocatoria.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },
  }
}
</script>
